import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/components/layout/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/app/components/layout/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PublicProviders"] */ "/app/components/layout/public-providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
